import Vue from 'vue'
import Router from 'vue-router'
import AnalyzerRoot from '@/components/AnalyzerRoot'
import StatementDetails from '@/components/StatementDetails'



Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'AnalyzerRoot',
      component: AnalyzerRoot,
      props: true,
    },
    {
      path: '/statement/:id',
      name: 'AnalyzerRoot',
      component: AnalyzerRoot,
      props: true,
    },
    {
      path: '/statement-detail/:id',
      name: 'StatementDetails',
      component: StatementDetails,
      props: true,
    },
    {
      path: '/statement-detail',
      name: 'StatementDetails',
      component: StatementDetails,
      props: true,
    },
  ],
})

export default router
